export default __webpack_public_path__ + "static/media/pill_seeking.54cd9194.svg";